<template>
  <div class="berita-by-category text-left bg-slate-50 mt-4 px-4 md:px-[15vw]">
    <div class="container mx-auto">
      <div class="bread-crumb md:text-xl text-sm">
        <router-link to="/">Home</router-link>
        <span class="mx-2">/</span>
        <span class="text-emerald-700 font-bold">{{ kategoriBerita[0]?.kategori }}</span>
      </div>

      <div class="title-category my-10 md:my-[5vh]">
        <TitleSection :title="kategoriBerita[0]?.kategori" />
      </div>

      <div class="warp-content">
        <div class="grid grid-cols-12 gap-4 my-4">
          <div class="col-span-12 md:col-span-8">
            <div
              v-for="(berita, index) in paginatedBerita"
              :key="index"
              class="card-berita w-full mb-4 flex gap-4 justify-center border-b border-b-gray-300 cursor-pointer"
              @click="navigateToDetail(berita)"
            >
              <div class="image-berita w-1/3">
                <img :src="berita.gambar" alt="Berita Image" class=" w-full max-h-[18vh]" />
              </div>
              <div class="detail-berita w-2/3 pb-3">
                <div
                  class="kategori-info text-emerald-700 text-sm font-extralight leading-normal"
                >
                  {{ berita.kategori }}
                </div>
                <div
                  class="judul-info text-emerald-700 text-l md:text-xl font-medium leading-none line-clamp-2 md:line-clamp-1 mt-2"
                >
                  {{ berita.judul }}
                </div>
                <div
                  class="waktu-info text-neutral-400 text-xs md:text-s mt-1 mb-4 font-normal leading-normal"
                >
                  {{ berita.tanggal }}
                </div>
                <div
                  class="deskripsi-info w-full text-sm line-clamp-3 text-gray-500 overflow-hidden leading-[1.4]"
                >
                  {{ berita.isi }}
                </div>
              </div>
            </div>
            <div class="pagination flex justify-center mt-6">
              <button
                v-for="page in visiblePages"
                :key="page + '-btn'"
                @click="typeof page === 'number' && goToPage(page)"
                :disabled="page === '...'"
                :class="[
                  'px-4 py-2 mx-1 border rounded',
                  page === currentPage ? 'bg-emerald-700 text-white' : 'bg-white text-emerald-700',
                  page === '...' && 'cursor-default text-gray-500'
                ]"
              >
                {{ page }}
              </button>
            </div>

          </div>
          <div class="md:col-span-4 hidden md:block">
            <MiniTitle title="Berita Terbaru" />
            <div
              class="card-very-new-berita mt-4 mb-2 cursor-pointer"
              v-for="(berita, index) in latestBerita"
              :key="index"
              @click="navigateToDetail(berita)"
            >
              <div class="text-very-new-berita text-xl font-bold line-clamp-3 leading-7 text-emerald-700 hover:text-emerald-900 cursor-pointer">
                {{ berita.judul }}
              </div>
              <hr class="my-4 border-t border-gray-300" v-if="index < latestBerita.length - 1" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useBeritaStore } from '@/store/beritaStore';
import TitleSection from '@/components/TitleSection.vue';
import MiniTitle from '@/components/MiniTitle.vue';

const route = useRoute();
const router = useRouter();
const beritaStore = useBeritaStore();
const kategoriBerita = ref([]);
const slugCat = route.params.slug_cat;

onMounted(() => {
  kategoriBerita.value = beritaStore.berita.filter(
    (berita) => berita.slug_cat === slugCat
  );
});

const currentPage = ref(1);
const itemsPerPage = 10;

const paginatedBerita = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return kategoriBerita.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.ceil(kategoriBerita.value.length / itemsPerPage);
});

const visiblePages = computed(() => {
  const pages = [];
  const total = totalPages.value;
  const current = currentPage.value;

  if (total <= 5) {
    for (let i = 1; i <= total; i++) pages.push(i);
  } else {
    pages.push(1);

    if (current > 3) {
      pages.push('...');
    }

    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (current < total - 2) {
      pages.push('...');
    }

    pages.push(total);
  }

  return pages;
});

const goToPage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

const latestBerita = computed(() => {
  return beritaStore.berita
    .slice()
    .sort((a, b) => new Date(b.created_time) - new Date(a.created_time))
    .slice(0, 4);
});

const navigateToDetail = (berita) => {
  router.push({
    name: 'DetailBerita',
    params: { slug_cat: berita.slug_cat, slug_berita: berita.slug_berita },
  });
};
</script>

<style scoped></style>
